/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAskOracleContainer = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 2v20H2V2h20zM11 20h9V4h-9v16zm-7 0h5v-2H4v2zm0-4h5V4H4v12z"
        fill="currentcolor"
      />
      <path
        d="M7 8v2H5V8h2zm11-2v2h-5V6h5zm0 4v2h-5v-2h5zm0 4v2h-5v-2h5zM8 12v2H6v-2h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAskOracleContainer as AskOracleContainer };
